import { render, staticRenderFns } from "./toPlatform.vue?vue&type=template&id=88054aea&scoped=true"
import script from "./toPlatform.vue?vue&type=script&lang=js"
export * from "./toPlatform.vue?vue&type=script&lang=js"
import style0 from "./toPlatform.vue?vue&type=style&index=0&id=88054aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88054aea",
  null
  
)

export default component.exports